import { render, staticRenderFns } from "./CartLimitModal.vue?vue&type=template&id=0f3c9217&scoped=true"
import script from "./CartLimitModal.vue?vue&type=script&lang=js"
export * from "./CartLimitModal.vue?vue&type=script&lang=js"
import style0 from "./CartLimitModal.vue?vue&type=style&index=0&id=0f3c9217&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c9217",
  null
  
)

export default component.exports